import { Link } from "react-router-dom";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

export default function PageNotFound() {
  return (
    <div className="bg-zinc-100 min-h-[82vh] flex flex-row items-center dark:bg-slate-700">
      <div className="container p-0 my-2">
        <div className="bg-white rounded-lg shadow-2xl p-8 mx-auto login-card w-3/4 sm:w-1/2 md:w-1/4 justify-center text-center dark:bg-slate-800 ">
          <div className="flex flex-col items-center max-w-sm mx-auto text-center">
            <p className="p-3 text-sm font-medium text-red-500 rounded-full bg-red-50 dark:bg-gray-800">
              <CancelOutlinedIcon />
            </p>
            <h1 className="mt-3 text-2xl font-semibold text-gray-800 dark:text-white md:text-3xl">
              Page not found
            </h1>
            <p className="mt-4 text-gray-500 dark:text-gray-400">
              The page you are looking for doesn&apos;t exist.
            </p>

            <div className="text-center w-full mt-6 gap-x-3 shrink-0 sm:w-auto">
              <Link
                className="w-1/2 px-5 py-2 text-sm tracking-wide text-white transition-colors duration-200 bg-blue-500 rounded-lg shrink-0 sm:w-auto hover:bg-blue-600 dark:hover:bg-blue-500 dark:bg-blue-600 text-nowrap"
                to={"/"}
              >
                Take me home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
